import { createBrowserHistory } from 'history';

/**
 * Shared browser history instance. Used with react-router's HistoryRouter so
 * we can call `appHistory.block(...)` to guard SPA navigations (e.g. leaving
 * Preferences with unsaved changes). react-router-dom 6.3 has no `useBlocker`.
 */
export const appHistory = createBrowserHistory();
